export const adminPrefix = '/admin';

export const app = {
  prefix: '/app/',

  graphReports: 'reports/graph',
  tableReports: 'reports/table',
  campaigns: 'campaigns',
  campaignsByCountry: 'campaignsByCountry',
  campaignsByCategory: 'campaignsByCategory',
  campaignsFillRate: 'fillRate',
  campaignsCountFillRate: 'campaignsCountFillRate',
  offers: 'offers',
  errorLogs: 'logs/errorLogs',
  requestLogs: 'logs/requestLogs',
  campaignLogs: 'logs/campaignLogs',
  offerWallLogs: 'logs/offerWallLogs',
  downloadCreativeErrorLogs: 'logs/downloadCreativeErrorLogs',
  apps: 'apps',
  placements: 'placements',
  apiStatuses: 'apiStatuses',
  impressions: 'impressions',
  leads: 'leads',
  clicks: 'clicks',
  accounts: 'accounts',
  accountManagers: 'accounts/managers',
  users: 'users',
  postbacks: 'postbacks',
  profile: 'profile',
  addApp: 'new-app',
  campaignDetails: 'campaigns/:campaignId',
  appDetails: 'apps/:appId',
  welcome: 'welcome',
  payments: 'payments',
  paymentDetails: 'payments/:paymentId',
  paymentAdjustments: 'payments/:paymentId/adjustments',
  playables: 'playables',
  testIntegration: 'testIntegration',
  userInterests: 'userInterests',
  messageLogs: 'messageLogs',

  impressionsReport: 'reports/impressions',

  globalSettings: 'globalSettings',
};

export const auth = {
  prefix: '/auth/',

  login: 'login',
  resetPassword: 'resetPassword',
  forgotPassword: 'forgotPassword',
};

export function getCampaignDetailsLink(campaignId) {
  return `${app.prefix}campaigns/${campaignId}`;
}

export function getAppDetailsLink(appId) {
  return `${app.prefix}apps/${appId}`;
}

export function getPaymentAdjustmentsLink(paymentId) {
  return `${app.prefix}payments/${paymentId}/adjustments`;
}



/** WEBPACK FOOTER **
 ** ./js/components/index/routes.js
 **/